<template>
  <div class="the-navbar__user-meta flex items-center cursor-pointer" v-if="activeCourseInfo" @click="enable_course_changer = true">

    <div class="con-img mr-4 ml-1 md:ml-0">
      <img :src="activeCourseInfo.selected && activeCourseInfo.thumbnail ? activeCourseInfo.thumbnail  : 'https://cdn.discordapp.com/attachments/810226104497340437/810282559187189811/cursor.png'" alt="user-img" width="40"
           height="40" draggable="false" class="rounded shadow-md cursor-pointer block"/>
    </div>

    <div class="text-left leading-tight hidden sm:block">
      <p class="font-semibold">{{ activeCourseInfo.name }}</p>
      <div style="min-width: 141px;">
        <vue-typer
          style="font-size: 10px; margin-top: 5px; "
          :text="activeCourseInfo.selected ? [&quot;Currently Practicing Course&quot;,&quot;Click Here to Select Course&quot;] : [&quot;Click Here to Select Course&quot;, &quot;You Have Not Selected a Course&quot;]"
          :repeat="Infinity"
          :shuffle="false"
          initial-action="erasing"
          :pre-type-delay="200"
          :type-delay="5"
          :pre-erase-delay="15500"
          :erase-delay="5"
          erase-style="backspace"
          :erase-on-complete="false"
          caret-animation="smooth"
        ></vue-typer>
      </div>
    </div>

    <vs-popup :active.sync="enable_course_changer" title="Change Course">
        <div v-if="courses_loaded" class="" style="max-height: 50vh">
          <div class="mb-4" v-if="current_course" >
            <course-drop-down-card :item="current_course" v-on:update_active_course="update_active_course" v-on:show_course_progress="show_course_progress"/>
          </div>
          <div v-for="item in courses_total" :key="item.id" class="mb-4" >
            <course-drop-down-card :item="item" v-on:update_active_course="update_active_course" v-on:show_course_progress="show_course_progress"/>
          </div>
          <h3 v-if="!current_course && courses_total.length === 0">You Have No Courses On Your Account</h3>
        </div>
      <course-drop-down-card-skeleton v-else/>
    </vs-popup>

  </div>
</template>

<script>
import CourseDropDownCardSkeleton from '@/components/skeleton-loading/CourseDropDownCardSkeleton'
import CourseDropDownCard from '@/layouts/components/navbar/components/course-drop-down/CourseDropDownCard'

export default {
  data () {
    return {
      enable_course_changer: false,
      current_course: null,
      courses_total: null,
      courses_loaded: false
    }
  },
  components: {
    CourseDropDownCard,
    CourseDropDownCardSkeleton
  },
  computed: {
    activeCourseInfo () {
      return this.$store.state.AppActiveCourse
    }
  },
  methods: {
    get_course_list () {
      this.$http.get('users/@me/subscriptions')
        .then(subscriptions => {

          const newCourses = []

          subscriptions.data.data.forEach(async x => {
            this.$http.get(`courses/${x.course_id}`)
              .then(async response => {
                if (response.status === 200 && response.data.data.status === 'active') {

                  if (response.data.data.id !== this.activeCourseInfo.id) {
                    newCourses.push(response.data.data)
                  } else {
                    this.current_course = response.data.data
                    this.current_course.selected = true
                  }

                }
              })
          })

          this.courses_total = newCourses
          this.courses_loaded = true

        })
    },
    update_active_course (x) {
      this.$vs.loading()

      const pl = {course_id: x}
      let rl = false

      if (this.$route.name === 'simulation-search') {
        rl = true
      }

      this.$http.post('users/@me/active-course', pl)
        .then(response => {
          this.$vs.loading.close()

          if (response.status === 200) {
            this.$store.dispatch('auth/refreshCourseObject').catch(() => {})
            this.enable_course_changer = false

            if (rl === false) {
              return this.$router.push('/simulation/search')
            }

            return this.$router.go()

          }
        }).catch(exception => {
          this.enable_course_changer = false
          return this.$vs.notify({
            color: 'danger',
            title: 'Failed to update course',
            text: exception.response.data.error.description,
            position: 'top-right'
          })
        })
    },
    show_course_progress (x) {
      this.$vs.loading()
      this.$router.push({name: 'course-view', params: {courseId: x }}).then(() => {
        this.enable_course_changer = false
        this.$vs.loading.close()
      })
    }
  },
  watch: {
    'enable_course_changer' () {
      if (this.enable_course_changer === true) {
        this.courses_loaded = false
        this.courses_total = null
        return this.get_course_list()
      }
    }
  }
}
</script>
<style lang="scss">


.vue-typer {
  .caret {
    background-color: transparent !important;
  }
}


</style>
